import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismComboSelectInput } from '@mylighthouse/prism-ember';
import type { Option } from '@mylighthouse/prism-ember/types/components/prism/select-input';
import GeneralDropdownsTriggersTriggerPowerSelectKebab from 'lumen/components/general/dropdowns/triggers/trigger-power-select-kebab';

const ACTION_TYPE = {
  HELP: 'help',
} as const;

type ActionType = (typeof ACTION_TYPE)[keyof typeof ACTION_TYPE];

type MoreActionsOption = Option & { action: ActionType };

interface SettingsCostDropdownsMoreActionsSignature {
  Element: HTMLDivElement;
}

/**
 * Kebab menu for the cost profile pages. For now the only entry is Help center,
 * which has no destination yet. Edit and Delete are added with the edit flow.
 */
export default class SettingsCostDropdownsMoreActions extends Component<SettingsCostDropdownsMoreActionsSignature> {
  @service declare intl: Services['intl'];

  get dropdownOptions(): MoreActionsOption[] {
    return [
      {
        action: ACTION_TYPE.HELP,
        icon: 'book',
        label: this.intl.t('general.help_center'),
        unsafe_isLink: true,
      },
    ];
  }

  @action onSelect(option: MoreActionsOption): void {
    switch (option.action) {
      case ACTION_TYPE.HELP:
        // The help-center destination is not wired up yet.
        break;
    }
  }

  <template>
    <PrismComboSelectInput
      @horizontalPosition="right"
      @onChange={{this.onSelect}}
      @options={{this.dropdownOptions}}
      @unsafe_triggerComponent={{GeneralDropdownsTriggersTriggerPowerSelectKebab}}
      data-test-id="cost-more-actions"
      ...attributes
    />
  </template>
}
